import { cn } from '@/lib/cn'
import { type PersonToken, initials, personPalette } from '@/lib/persons'

const SIZES = {
  sm: 'size-7 text-[11px]',
  md: 'size-9 text-[13px]',
  lg: 'size-12 text-base',
  xl: 'size-16 text-xl',
} as const

/**
 * Avatar de un integrante.
 *
 * Lleva iniciales además del color: el color solo no puede ser el único
 * portador de identidad, ni para quien no distingue ciertos tonos ni para un
 * lector de pantalla.
 */
export function PersonAvatar({
  name,
  token,
  size = 'md',
  selected = false,
  className,
}: {
  name: string
  token: PersonToken | string | null | undefined
  size?: keyof typeof SIZES
  selected?: boolean
  className?: string
}) {
  const palette = personPalette(token)

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-white',
        'transition-transform duration-200',
        SIZES[size],
        palette.fill,
        selected && 'ring-2 ring-ink ring-offset-2 ring-offset-bg',
        className,
      )}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  )
}

/** Punto de color para filas de lista y leyendas de gráfica. */
export function PersonDot({
  token,
  className,
}: {
  token: PersonToken | string | null | undefined
  className?: string
}) {
  return (
    <span
      aria-hidden="true"
      className={cn('inline-block size-2 shrink-0 rounded-full', personPalette(token).fill, className)}
    />
  )
}
